export default {
  lang: "Suomi",

  // Dextra Content
  welcome: "Dextra videoneuvonta",
  s_services: "Dextra palvelut",
  s_tracking: "Palvelun seuranta",
  s_record: "Asiakirjapalvelut",
  s_redirect: "Palvelun uudelleenohjaus",
  s_adress: "Osoitepalvelut",
  s_feedback: "Asiakastuki",
  privacy: "Yksityisyytesi on tärkeää. Keskusteluja käsitellään luottamuksellisesti eikä niitä tallenneta.",
  agentAvailability: "Agentin saatavuus",
  available: "Saatavissa",
  unavailable: "Ei saatavilla",
  connecting_title: "Yhdistetään...",
  connecting_message: "Odota hetki.",
  cancel: "Peruuta",
  button_start: "Aloita tästä"
}
